import OfficeContainer from "../../../components/offices"

const Offices = () => {
  return (
    <OfficeContainer />
  )
}

export default Offices